import { Box, Skeleton } from "@mui/material";

import { g } from "./shared/tokens";

const CreateNicheTemplateCardLoading = () => {
  return (
    <Box
      sx={{
        background: g.panelBg,
        border: `1px solid ${g.border}`,
        borderRadius: g.radiusXl,
        p: { xs: "20px", md: "28px" },
        maxWidth: 1000,
      }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "space-between", mb: "18px" }}
      >
        <Box>
          <Skeleton variant="text" width={220} height={28} />
          <Skeleton variant="text" width={300} height={20} />
        </Box>
        <Skeleton
          variant="rounded"
          width={140}
          height={24}
          sx={{ borderRadius: "999px" }}
        />
      </Box>

      <Box
        sx={{
          background: g.cardBg,
          border: `1px solid ${g.border}`,
          borderRadius: g.radiusLg,
          p: { xs: "16px", md: "22px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            mb: "16px",
          }}
        >
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="text" width={200} height={24} />
        </Box>
        <Skeleton
          variant="rounded"
          width="100%"
          height={64}
          sx={{ borderRadius: g.radiusMd }}
        />
        <Skeleton
          variant="rounded"
          width="100%"
          height={42}
          sx={{ borderRadius: g.radiusSm, mt: "18px" }}
        />
      </Box>
    </Box>
  );
};

export default CreateNicheTemplateCardLoading;
